//#region libraries

import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// custom components
import { Card, CustomSpinner, Container } from '_atoms';
import AllBeaconTimes from '../all-beacons';
import WaitingAreas from '../waiting-areas';
// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectUserDb, selectIata } from '_redux/slices/main-screen/user';
import { selectAirportInformation } from '_redux/slices/analytics/reviews';
import { selectWaitingTimes, selectWaitingTimesStatus, getWaitingTimes } from '_redux/slices/analytics/reviews';
import * as AirportService from '_services/airport-service';


// tremor
import { Title as TremorTitle, Button, Text, AreaChart, Flex, TabList, Tab, Dropdown, DropdownItem } from '@tremor/react';

// styles

const ObjectsToCsv = require("objects-to-csv")
//#endregion



const requestCSV = async (props) => {
    try {

        const method = "getWaitingTimes"
        const response = await AirportService[method]({ iata: props.iata, type: props.date, csv: true, taskType: props.taskType });
        const csv = await new ObjectsToCsv(response.data)
        const csv_string = await csv.toLocaleString();
        const element = document.createElement("a");
        const file = new Blob([csv_string], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        const date = new Date().toISOString().split('T')[0];
        const fileName = "Waiting Time"
        element.download = `${fileName}_${date}_${props.date}_${props.iata}.csv`;
        document.body.appendChild(element);
        element.click();
    } catch (e) {
        alert('FAILED ' + e)
    }
    props.setCsvIsLoading(false)
}

const WaitingTimes = () => {

    //#region redux
    const dispatch = useDispatch()

    const airportInformation = useSelector(selectAirportInformation)
    const dbUser = useSelector(selectUserDb)
    const iata = useSelector(selectIata)
    const airportName = airportInformation?.[dbUser?.details?.authority]?.name ? airportInformation?.[dbUser?.details?.authority]?.name : "Your Airport"
    const waitingTimes = useSelector(selectWaitingTimes);
    const status = useSelector(selectWaitingTimesStatus)

    //#endregion


    const [csvIsLoading, setCsvIsLoading] = useState(false)
    const [taskType, setTaskType] = useState("departure");
    const [date, setDate] = useState("today");


    const dateDescription = {
        "last48hrs": "in the last 48 hours",
        "today": "since midnight today",
        "lastweek": "in the last 7 days"
    }

    const handleSelect = (taskType) => {
        setTaskType(taskType)
    }

    const handleChangeDate = (date) => {
        setDate(date)
    }

    useEffect(() => {
        if (!iata) return;

        const taskTypeFilter = ["BRS", "GLA"].includes(iata) ? "all" : taskType
        const props = {
            iata,
            type: date,
            taskType: taskTypeFilter
        }
        dispatch(getWaitingTimes(props))

    }, [taskType, date])


    return (
        <>

            <Row className='mt-3'>
                <Col>
                    <Card>
                        <Container>

                            {/* Top Row */}
                            <Row>
                                <Col md={4}></Col>
                                <Col md={8}>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: 2 }}>
                                        <Col md={3}>
                                            {!["BRS", "GLA"].includes(iata) && (
                                                <Dropdown
                                                    onValueChange={handleSelect}
                                                    value={taskType}
                                                    placeholder="Select task"
                                                >
                                                    {["all", "departure", "boarding", "ramp", "arrival"].map((type) => (
                                                        <DropdownItem
                                                            key={type}
                                                            value={type}
                                                            text={type}  // Tremor's DropdownItem uses 'text' prop
                                                        />
                                                    ))}
                                                </Dropdown>
                                            )}
                                        </Col>
                                        <Col md={3}>
                                            <Dropdown
                                                onValueChange={handleChangeDate}
                                                value={date}
                                                placeholder="Select Date range"
                                            >
                                                {["today", "last48hrs", "lastweek"].map((date) => (
                                                    <DropdownItem
                                                        key={date}
                                                        value={date}
                                                        text={date}  // Tremor's DropdownItem uses 'text' prop
                                                    />
                                                ))}
                                            </Dropdown>
                                        </Col>
                                        <Col md={2}>
                                            <Button variant={"outline-secondary"} onClick={() => { setCsvIsLoading(true); requestCSV({ iata: iata, setCsvIsLoading: setCsvIsLoading, date, taskType }) }} loading={csvIsLoading} style={{ width: 150, marginLeft: 15 }}>Export Data</Button>

                                        </Col>

                                    </div>


                                </Col>
                            </Row>

                            {/* Title + Button */}
                            <Row>
                                <Flex>
                                    <Container className='mt-2'>
                                        <TremorTitle>{`${airportName}'s Passenger Waiting Times`}</TremorTitle>
                                        <Text>{`The average waiting time in ${airportName} ${dateDescription?.[date]}.` + ((status == "loading") || !(waitingTimes?.numProcessedPassengers) ? '' : ` (Data from ${waitingTimes.numProcessedPassengers} passengers)`)}</Text>
                                    </Container>
                                </Flex>
                            </Row>

                            {/* Graph */}
                            {
                                (status == "loading") ? <CustomSpinner rowCenter={true} /> :
                                    <AreaChart
                                        data={Object.keys(waitingTimes).length ? waitingTimes.graphData : ''}
                                        dataKey='hour'
                                        categories={['Waiting Time (minutes)']}
                                        colors={['blue', 'green']}
                                        marginTop='mt-4'
                                        yAxisWidth='w-10'
                                    />}


                        </Container>
                    </Card>
                </Col>
            </Row>
            {/* TODO, NEED TO INTEGRATE IT WITH LOCAL DATA */}
            <Row className='mt-3' style={{ marginBottom: 22 }}>
                <WaitingAreas />
            </Row>

            <Row className='mt-3' style={{ marginBottom: 22 }}>
                <AllBeaconTimes />
            </Row>

        </>
    );
};

export default WaitingTimes;
